// import { User } from "../types/types";

const USER_KEY = "user";

export const getUserFromLocalStorage = () => {
  const x = localStorage.getItem(USER_KEY);
  return x ? JSON.parse(x) : null;
};
